import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--customers"
export default class extends Controller {
  static targets = [
    "form",
    "content",
    "showFormButton"
  ]

  static values = {
    show: String,
    action: String
  }

  connect() {
    this.elFormTarget = document.querySelector("[data-admins--customers-target='form']")
    this.elContentTarget = document.querySelector("[data-admins--customers-target='content']")
    this.elButtonTarget = document.querySelector("[data-admins--customers-target='showFormButton']")

    if (this.showValue === "form" || this.actionValue === "edit") {
      this.elFormTarget.classList.remove("hidden")
      this.elContentTarget.classList.add("hidden")
    }

    if (this.showValue === "content") {
      this.elContentTarget.classList.remove("hidden")
      this.elFormTarget.classList.add("hidden")

      this.elButtonTarget.classList.remove("hidden")
    }
  }

  showForm() {
    this.formTarget.classList.remove("hidden")
    this.contentTarget.classList.add("hidden")

    this.showFormButtonTarget.classList.add("hidden")
  }

  showContent() {
    this.formTarget.classList.add("hidden")
    this.contentTarget.classList.remove("hidden")

    this.showFormButtonTarget.classList.remove("hidden")
  }
}
